var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9921 8.93199C7.35417 7.06341 10.2629 5.83153 11.7183 5.23635C15.8737 3.53698 16.7372 3.24179 17.3 3.23204C17.4238 3.22989 17.7005 3.26006 17.8798 3.40308C18.0312 3.52385 18.0728 3.687 18.0928 3.8015C18.1127 3.916 18.1375 4.17685 18.1178 4.38066C17.8926 6.70697 16.9182 12.3523 16.4225 14.9578C16.2128 16.0603 15.7998 16.4299 15.3999 16.4661C14.531 16.5447 13.8712 15.9015 13.0295 15.3591C11.7126 14.5103 10.9686 13.9819 9.69027 13.1537C8.21293 12.1965 9.17063 11.6704 10.0126 10.8106C10.2329 10.5856 14.0615 7.16168 14.1356 6.85108C14.1448 6.81223 14.1534 6.66743 14.0659 6.59098C13.9784 6.51452 13.8493 6.54066 13.7561 6.56146C13.624 6.59093 11.5202 7.95815 7.44458 10.6631C6.84741 11.0663 6.30651 11.2627 5.82188 11.2524C5.28762 11.2411 4.25991 10.9554 3.49592 10.7113C2.55885 10.4118 1.81408 10.2534 1.87894 9.7448C1.91272 9.47987 2.28377 9.20894 2.9921 8.93199Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/IconTelegram.be0af5c75ada63bf2d55690ba4d44bdd.svg";
export { ForwardRef as ReactComponent };